import { render, staticRenderFns } from "./tabChargesNoResize.vue?vue&type=template&id=48b09395&"
import script from "./tabChargesNoResize.vue?vue&type=script&lang=js&"
export * from "./tabChargesNoResize.vue?vue&type=script&lang=js&"
import style0 from "./tabChargesNoResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b09395')) {
      api.createRecord('48b09395', component.options)
    } else {
      api.reload('48b09395', component.options)
    }
    module.hot.accept("./tabChargesNoResize.vue?vue&type=template&id=48b09395&", function () {
      api.rerender('48b09395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabChargesNoResize.vue"
export default component.exports